import { buildsServiceApi } from "../../api";
import { GetObjectsResponse } from "../../api/object/types";

type GetObjectsRequest = {
  limit: number | undefined;
  page: number | undefined;
  projectId: string | undefined;
};

export const getObjects = async (
  data: GetObjectsRequest,
): Promise<GetObjectsResponse> => {
  const response = await buildsServiceApi.get(
    `projects/${data.projectId}/building-objects`,
    {
      params: {
        limit: data.limit || 1000,
        page: data.page || 1,
      },
    },
  );
  return response.data;
};
